module.exports = __webpack_public_path__ + "assets/img/4_103.fdb5e90e.jpg";